import { ListParticularHistory } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const ListPincodeHistory = {
  data: () => ({}),
  methods: {
    async ListPincodeHistoryMethod(Pincode_Id) {
      try {
        let inputParams = {
          organization_id:
            this.$store.getters.get_current_user_details.organization_id,
          user_id: this.$store.getters.get_current_user_details.user_id,
          history_id: Pincode_Id,
          limit: 100,
        };

        let result = await client.graphql({
          query: ListParticularHistory,
          variables: {
            input: inputParams,
          },
        });

        let ResultObj = JSON.parse(result.data.ListParticularHistory).data
          .items;
        
        return ResultObj;
      } catch (error) {
        
      }
    },
  },
};
